// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ErrorComponent$OrcaPaymentPage from "./ErrorComponent.bs.js";

function VGSInputComponent(props) {
  var __height = props.height;
  var __compact = props.compact;
  var __isFocused = props.isFocused;
  var __id = props.id;
  var __fieldName = props.fieldName;
  var fieldName = __fieldName !== undefined ? __fieldName : "";
  var id = __id !== undefined ? __id : "";
  var isFocused = __isFocused !== undefined ? __isFocused : false;
  var compact = __compact !== undefined ? __compact : false;
  var height = __height !== undefined ? __height : "";
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var config = match.config;
  var match$1 = config.appearance;
  var innerLayout = match$1.innerLayout;
  var match$2 = React.useState(function () {
        return "";
      });
  var setFocusClass = match$2[1];
  React.useEffect((function () {
          setFocusClass(function (param) {
                if (isFocused) {
                  return "VGSField--focused";
                } else {
                  return "";
                }
              });
        }), [isFocused]);
  var inputClassStyles = innerLayout === "Spaced" ? "Input" : "Input-Compressed";
  return React.createElement("div", {
              className: "flex flex-col w-full",
              style: {
                color: themeObj.colorText
              }
            }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: fieldName.length > 0 && config.appearance.labels === "Above" && innerLayout === "Spaced",
                  children: React.createElement("div", {
                        "aria-hidden": true,
                        className: "Label Label--empty",
                        style: {
                          fontSize: themeObj.fontSizeLg,
                          fontWeight: themeObj.fontWeightNormal,
                          marginBottom: "5px",
                          opacity: "0.6"
                        }
                      }, fieldName)
                }), React.createElement("div", {
                  className: "flex flex-row",
                  style: {
                    direction: "ltr"
                  }
                }, React.createElement("div", {
                      className: "relative w-full"
                    }, React.createElement("div", {
                          className: "flex flex-col w-full",
                          style: {
                            color: themeObj.colorText
                          }
                        }, React.createElement("div", {
                              className: "flex flex-row"
                            }, React.createElement("div", {
                                  className: inputClassStyles + " Input--empty focus:outline-none transition-shadow ease-out duration-200 " + match$2[0],
                                  id: id,
                                  style: {
                                    background: themeObj.colorBackground,
                                    height: height,
                                    padding: compact ? "0px " + themeObj.spacingUnit : themeObj.spacingUnit,
                                    width: "100%",
                                    boxSizing: "border-box"
                                  }
                                })), React.createElement(ErrorComponent$OrcaPaymentPage.make, {
                              errorStr: Caml_option.some(props.errorStr)
                            })))));
}

var make = VGSInputComponent;

export {
  make ,
}
/* jotai Not a pure module */
